/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".back-button[_ngcontent-%COMP%]{display:inline-block;margin-top:15px;color:#91a3b1;cursor:pointer;transition:all .2s ease}.back-button[_ngcontent-%COMP%]:hover{color:#eb0929}"];
export { styles as styles };
